import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { usePageTitle } from '../hooks/usePageTitle';
import './NotFoundPage.css';

const NotFoundPage: React.FC = () => {
  const { t } = useTranslation();
  usePageTitle('Page Not Found');

  return (
    <div className="notfound-page">
      <section className="notfound-hero">
        <div className="container">
          <span className="notfound-code" aria-hidden="true">404</span>
          <h1>{t('notFound.title')}</h1>
          <p>{t('notFound.message')}</p>
          <Link to="/" className="btn btn-primary">{t('notFound.backHome')}</Link>
        </div>
      </section>
    </div>
  );
};

export default NotFoundPage;
